module.exports = __webpack_public_path__ + "img/hero-mobile_en.6e05468.jpg";